import { Helmet } from 'react-helmet';
import { useEffect } from 'react';
import { pageView } from '../../scripts/analytics';

import PageLayout from '../../layouts/PageLayout';
import Header from '../../components/blocks/Header';
import Textblock from '../../components/blocks/Textblock';

import topVisual from '../../assets/images/programmering-top.jpg';
import espnVandaagImg from '../../assets/images/programmering-espn-vandaag.jpg';
import eretribuneImg from '../../assets/images/programmering-eretribune.png';
import goedemorgenEredivisieImg from '../../assets/images/programmering-goedemorgen-eredivisie.png';
import voetbalVrijdagImg from '../../assets/images/programmering-voetbal-vrijdag.jpg';
import studioEuropaImg from '../../assets/images/programmering-studio-europa.jpg';
import weekendImg from '../../assets/images/programmering-weekend.jpg';
import voetbalpraatImg from '../../assets/images/programmering-voetbalpraat.jpg';
import clubTvImg from '../../assets/images/programmering-clubtv.jpg';
import alleStatenImg from '../../assets/images/programmering-alle-staten.jpg';
import voetbalKantineImg from '../../assets/images/programmering-voetbalkantine.jpg';
import parkerenImg from '../../assets/images/programmering-parkeren.jpg';

const Programmering = () => {
    useEffect(() => {
        pageView('programmering');
    }, []);

    return (
        <PageLayout>
            <Helmet>
                <title>ESPN - Kijk alle Eredivisie wedstrijden live!</title>
                <meta
                    name="description"
                    content="Wil je niks meer missen van de Eredivisie? Neem ESPN Compleet en kijk alle wedstrijden live."
                />
                <meta
                    property="og:title"
                    content="ESPN - Kijk alle Eredivisie wedstrijden live!"
                />
                <meta
                    property="og:description"
                    content="Wil je niks meer missen van de Eredivisie? Neem ESPN Compleet en kijk alle wedstrijden live."
                />
                <meta property="og:type" content="website" />
                <meta property="og:image" content={topVisual} />
            </Helmet>
            <Header
                image={topVisual}
                title="ESPN Programmering"
                buttons={[
                    {
                        label: 'Bekijk Programmering',
                        link: '#programs',
                        type: 'primary',
                        size: 'large',
                    },
                ]}
            />
            <div id="programs" />
            <Textblock
                title="ESPN Vandaag"
                text={
                    <>
                        Een round-up van de dag op ESPN met het belangrijkste en
                        opvallendste (inter)nationale sportnieuws, dagelijks om
                        18.30 en 23.00 uur. In ESPN Vandaag wordt de kijker op
                        ESPN in een half uur volledig bijgepraat aan de hand van
                        samenvattingen, reportages, rubrieken en sociale media.
                        <br />
                        <br />
                        ESPN Vandaag wordt gepresenteerd door verschillende
                        presentatoren, waaronder Pascal Kamperman, Aletha
                        Leidelmeijer, Fresia Cousiño Arias, Milan van Dongen,
                        Vincent Schildkamp en Wouter Bouwman.
                    </>
                }
                links={[
                    {
                        url: 'https://www.espn.nl/watch/catalog/3be381e4-beec-4f48-a5f7-030f4e40d953',
                        label: 'Kijk op watch',
                    },
                ]}
                image={espnVandaagImg}
                screen={true}
            />
            <Textblock
                title="De Eretribune"
                text={
                    <>
                        De Eretribune is hét zaterdagavondprogramma van ESPN.
                        Jan Joost van Gangelen en Aletha Leidelmeijer ontvangen
                        elke week gasten en analisten en kijken samen met hen
                        met speciale aandacht naar een zaterdagavondwedstrijd.
                        <br />
                        <br />
                        Uiteraard komen ook de hoogtepunten uit de andere duels
                        voorbij en maken we het zaterdagavondgevoel compleet met
                        een leuke voetbalquiz. Kortom, de zaterdagavond is er
                        een om voor thuis te blijven.
                    </>
                }
                links={[
                    {
                        url: 'https://www.espn.nl/watch/catalog/d6181b8c-f9b1-421b-8e76-7dc87213de4e/de-eretribune',
                        label: 'Kijk op watch',
                    },
                ]}
                image={eretribuneImg}
                screen={true}
                revert={true}
            />
            <Textblock
                title="Goedemorgen Eredivisie"
                text={
                    <>
                        De ideale voetbalzondag begint om 10.00 uur op ESPN.
                        Afgewisseld gepresenteerd door Milan van Dongen en
                        Fresia Cousiño Arias blikken hoofdrolspelers uit de
                        voetbalwereld samen met Hans Kraay Jr. terug op de
                        wedstrijden van vrijdag en zaterdag - en vooral ook
                        vooruit naar de duels van zondag. Met altijd een
                        verslaggever ter plaatse in het stadion waar in de
                        Eredivisie om 12:15 uur wordt afgetrapt.
                    </>
                }
                links={[
                    {
                        url: 'https://www.espn.nl/watch/catalog/7578611c-4e28-4202-aab3-17428bb2e7c0/goedemorgen-eredivisie',
                        label: 'Kijk op watch',
                    },
                ]}
                image={goedemorgenEredivisieImg}
                screen={true}
            />
            <Textblock
                title="Voetbal op Vrijdag"
                text={
                    <>
                        Live programma waarin wordt geschakeld tussen alle
                        wedstrijden van vrijdag uit de Eredivisie en Keuken
                        Kampioen Divisie.
                    </>
                }
                image={voetbalVrijdagImg}
                screen={true}
                revert={true}
            />
            <Textblock
                title="Studio Europa"
                text={
                    <>
                        Studioprogramma van ESPN rondom de wedstrijden in de
                        UEFA Europa League en UEFA Conference League.
                    </>
                }
                image={studioEuropaImg}
                screen={true}
            />
            <Textblock
                title="Dit Was Het Weekend"
                text={
                    <>
                        Na de laatste Eredivisiewedstrijd worden op zondag in
                        Dit Was Het Weekend de belangrijkste en opvallendste
                        zaken van het Eredivisieweekend geduid door Jan Joost
                        van Gangelen of Milan van Dongen en twee analisten.
                    </>
                }
                links={[
                    {
                        url: 'https://www.espn.nl/watch/catalog/d56f6c57-e299-4c4d-b313-612d754b40ea/dit-was-het-weekend',
                        label: 'Kijk op watch',
                    },
                ]}
                image={weekendImg}
                screen={true}
                revert={true}
            />
            <Textblock
                title="Voetbalpraat"
                text={
                    <>
                        Voetbalpraat is niet meer weg te denken uit de
                        programmering. Tijdens het seizoen neemt meerdere keren
                        per week een gezelschap van vier presentatoren,
                        analisten en gasten plaats in hun hokje om alle hoofd-
                        én randzaken uit de voetbalwereld in twee helften van 22
                        minuten te bespreken. Ook te beluisteren als podcast.
                    </>
                }
                links={[
                    {
                        url: 'https://www.espn.nl/watch/catalog/f6561670-492a-4c32-b697-c74f37c17ac2/voetbalpraat',
                        label: 'Kijk op watch',
                    },
                    {
                        url: 'https://open.spotify.com/show/4lpkuJibQKPzuW9TTMMLQg',
                        label: 'Luister de Podcast',
                    },
                ]}
                image={voetbalpraatImg}
                screen={true}
            />
            <Textblock
                title="Club TV"
                text={
                    <>
                        Fans komen via ESPN nog dichter bij hun club dankzij
                        Club TV. Met uiteraard veel uitzendingen van de
                        traditionele top-3, Club TV Specials, wekelijkse
                        magazines en mooie documentaires.
                    </>
                }
                links={[
                    {
                        url: 'https://www.espn.nl/watch/catalog/dca95d53-b3c7-4c80-a0ff-bcd5a268b2f4/club-tv#bucketId=1',
                        label: 'Kijk op watch',
                    },
                ]}
                image={clubTvImg}
                screen={true}
                revert={true}
            />
            <Textblock
                title="ESPN in alle Staten"
                text={
                    <>
                        In ESPN in alle Staten komen iedere week nieuws,
                        highlights en de mooiste verhalen uit de Amerikaanse
                        sporten aan bod. Met o.a. NFL, NBA, NHL, MLB, College
                        Basketball en College Football. Gepresenteerd door Sanne
                        van Dongen en met de rubriek Mart’s Madness van Mart
                        Smeets.
                    </>
                }
                links={[
                    {
                        url: 'https://www.espn.nl/watch/catalog/20e9002c-be8f-4514-b954-9bdfe5783354/espn-in-alle-staten',
                        label: 'Kijk op watch',
                    },
                ]}
                image={alleStatenImg}
                screen={true}
            />
            <Textblock
                title="De Voetbalkantine"
                text={
                    <>
                        Wouter Bouwman presenteert vanaf dit seizoen samen met
                        podcastmaker en voetbalcultuurconnaisseur Yordi Yamali
                        het nieuwe zondagmiddagprogramma ‘De Voetbalkantine’.
                        Met verschillende gasten bespreken ze de
                        voetbalactualiteit en alles wat voetbal zo mooi maakt.
                        Ook komen de mooiste momenten van het weekend voorbij
                        uit de Eredivisie, Keuken Kampioen Divisie en Azerion
                        Vrouwen Eredivisie.
                    </>
                }
                links={[
                    {
                        url: 'https://www.espn.nl/watch/catalog/2a63849f-47ff-490a-a7a1-acbbfe3805ea/de-voetbalkantine',
                        label: 'Kijk op watch',
                    },
                ]}
                image={voetbalKantineImg}
                screen={true}
                revert={true}
            />
            <Textblock
                title="Fresia en Milan parkeren de bus"
                text={
                    <>
                        Iedere dinsdag na een Eredivisieweekend duiken Milan van
                        Dongen en Fresia Cousiño Arias hun eigen voetbalbus in
                        met een (hoofdrol)speler uit het Nederlandse voetbal.
                        Het interview wordt als podcast gepubliceerd onder de
                        naam ‘Fresia en Milan parkeren de bus’ en daarnaast zijn
                        de video-opnames van het interview te zien op tv.
                    </>
                }
                links={[
                    {
                        url: 'https://open.spotify.com/show/3Tkwt0WQAnSKae32dMOKZ2',
                        label: 'Luister de Podcast',
                    },
                ]}
                image={parkerenImg}
                screen={true}
            />
        </PageLayout>
    );
};

export default Programmering;
